import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    StyledFilterContent,
    StyledQuickFilterBorder,
} from 'src/pages/orders/components/quickFilters/QuickFilters.styled';

export const TabGridContianer = styled.ul`
    display: grid;
    grid-auto-rows: 3.5em;
    margin-left: -47px !important;
    grid-template-columns: repeat(7, 1fr) 1.2fr;
    ${media.smalDevice`
    grid-template-columns: repeat(7,1fr) 1.2fr;
`}
    ${media.mobileDevice`
    margin-left: 0px;
    grid-template-columns: repeat(2,1.2fr)};
    gap: 0px;
    height: 30px;
`}
`;

export const StyledTabContentContianer = styled.li`
    display: flex;
    flex-direction: column;
    opacity: 1;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};

    height: 40px;
    width: 176px;
    box-sizing: border-box;
    background-color: ${({ isSelected }) =>
        isSelected ? '#FFFFFF' : '#EBEDED'};
    border: 0.5px solid #d7dbdb;
    box-shadow: ${({ isSelected }) =>
        isSelected ? '0px 0px 6px #00000014' : ''};

    ${media.mobileDevice`
    height: 70%;
    width: 100%;
    box-sizing: border-box;
    background-color: ${({ isSelected }) =>
        isSelected ? '#FFFFFF' : '#EBEDED'}; 
    border: 0.5px solid #d7dbdb;
    `}
`;

export const TabContent = styled(StyledFilterContent)`
    width: max-content;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    ${media.mediumDevice`
        padding: 0 0.3rem;
       
    `}
    ${media.smalDevice`
        padding: 0 0.2rem;
    `}
    ${media.mobileDevice`
        padding: 0 0.4rem;
        width: 100%;
    `}
`;

export const TabSelectedBorder = styled(StyledQuickFilterBorder)``;

export const TabContentFont = styled.p`
    display: block;
    text-align: left;
    padding-top: 3px;
    color: ${({ isSelected }) => (isSelected ? '#1010EB' : '#202124')};
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    line-height: 16px;
    ${media.smalDevice`
        margin: 0 18px;
    `}
    ${media.mobileDevice`
        margin: 0;
        text-align: center;
        font-size: 13px;
        color: ${({ isSelected }) => (isSelected ? '#1010EB' : '#202124')};
    `}
`;
